"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invites = void 0;
const BondBaseEntity_1 = require("../../entity/BondBaseEntity");
// NOTE: organizationId must be integer to match Organization and project standards, and to ensure correct FK in migrations
class Invites extends BondBaseEntity_1.BondBaseEntity {
}
exports.Invites = Invites;
//# sourceMappingURL=invites.entity.js.map